import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';

import { RolePage } from '~/features/workspace/roles/role-page';

function RoleRoute(): ReactElement {
  const { roleId } = Route.useParams();
  // Keyed by the role, so moving from one role to another starts a fresh page.
  return <RolePage key={roleId} roleId={roleId} />;
}

/** One role: what it lets people do, and who holds it (web-redesign-03 phase 2.2). */
export const Route = createFileRoute('/_app/business/roles/$roleId')({ component: RoleRoute });
